import React from 'react';

import './styles.css';

import studentsServices from '../../../../../services/academy/studentsServices';

import { FaDollarSign, FaUserSlash } from 'react-icons/fa'

export default function ClassStudentsCardItem(props) {
    async function updateStudentClass() {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(`Remover ${props.name} da turma?`)) {
            const response = await studentsServices.patchStudentClass(props.id, null);
            if (response.status === 200) {
                props.onDelete(props.index);
            } else
                alert("Erro ao remover aluno da turma, tente novamente!");
        }
    }

    return (
        <li className='class-card-students-list-item'>
            <div>
                {
                    props.photo ?
                        <img src={props.photo} alt="Foto de perfil do aluno" />
                        : <span />
                }
                <p className='student-name'><b>{props.name}</b></p>
            </div>
            <button className="delete" type="button" onClick={updateStudentClass}><FaUserSlash /></button>
            {
                props.coachMode ?
                    [] :
                    <button
                        className="payment"
                        onClick={() => props.showPopup({
                            id: props.id,
                            name: props.name,
                            photo: props.photo
                        })}
                    ><FaDollarSign /></button>
            }
        </li>
    )
}